(function() {
  var path = window.location.pathname.toLowerCase();
  var rules = [
    // ============================================================
    // BASIC CLEANUP RULES (1-5)
    // ============================================================
    
    // Rule 1: Supprimer index.php seul
    [/^\/index\.php\/?$/, '/'],
    
    // Rule 2: Supprimer locale ca-en
    [/^\/ca-en\/?$/, '/'],
    
    // Rule 3: Supprimer locale ca-fr
    [/^\/ca-fr\/?$/, '/'],
    
    // Rule 4: Supprimer locale en
    [/^\/en\/?$/, '/'],
    
    // ============================================================
    // STATIC PAGES (5-17)
    // ============================================================
    
    // Rule 5: Login pages
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/login\/?$/, '/account/login'],
    
    // Rule 6: Customer overview
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/customer\/overview\/?$/, '/account'],
    
    // Rule 7: Shipping pages
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/shipping(-2)?\/?$/, '/policies/shipping-policy'],
    
    // Rule 8: Sitemaps
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/sitemap\.xml$/, '/sitemap.xml'],
    
    // Rule 9: Products XML
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/products\.xml$/, '/sitemap.xml'],
    
    // Rule 10: Cart
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/cart\/?$/, '/cart'],
    
    // Rule 11: FAQ EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/faq(-1|-2)?\/?$/, '/pages/faq'],
    
    // Rule 12: FAQ FR
    [/^(\/index\.php)?\/ca-fr\/faq(-1|-2)?\/?$/, '/fr/pages/faq'],
    
    // Rule 13: Termes FR
    [/^(\/index\.php)?(\/ca-fr)?\/termes-et-conditions\/?$/, '/fr/policies/terms-of-service'],
    
    // Rule 14: Privacy FR
    [/^(\/index\.php)?(\/ca-fr|\/fr)?\/politique-de-confidentialite\/?$/, '/fr/policies/privacy-policy'],
    
    // Rule 15: Livraison FR
    [/^(\/index\.php)?(\/ca-fr)?\/livraison\/?$/, '/fr/policies/shipping-policy'],
    
    // Rule 16: Inspiration
    [/^(\/index\.php)?(\/ca-en|\/ca-fr)?\/inspiration(-1)?\/?$/, '/'],
    
    // Rule 17: Promotions
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/promotions?\/.*$/, '/collections/sale'],
    
    // ============================================================
    // PRODUCT CATEGORIES (18-32)
    // ============================================================
    
    // Rule 18: Catégories gabion EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/.*gabion.*$/, '/collections/gabions'],
    
    // Rule 19: Catégories gabion FR
    [/^(\/index\.php)?\/ca-fr\/(categorie-de-produits)\/.*gabion.*$/, '/fr/collections/gabions'],
    
    // Rule 20: Catégories fire EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/.*(fire).*$/, '/collections/fire-stones'],
    
    // Rule 21: Catégories foyer FR
    [/^(\/index\.php)?\/ca-fr\/(categorie-de-produits)\/.*(foyer).*$/, '/fr/collections/pierres-de-feu-1'],
    
    // Rule 22: Catégories lava EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/.*(lava).*$/, '/collections/lava-rocks'],
    
    // Rule 23: Catégories lave FR
    [/^(\/index\.php)?\/ca-fr\/(categorie-de-produits)\/.*(lave).*$/, '/fr/collections/pierres-de-lave'],
    
    // Rule 24: Catégories glass EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/.*(glass).*$/, '/collections/glass'],
    
    // Rule 25: Catégories verre FR
    [/^(\/index\.php)?\/ca-fr\/(categorie-de-produits)\/.*(verre).*$/, '/fr/collections/verre'],
    
    // Rule 26: Catégories landscaping EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/.*(landscaping).*$/, '/collections/landscaping-stones'],
    
    // Rule 27: Catégories paysagement FR
    [/^(\/index\.php)?\/ca-fr\/(categorie-de-produits)\/.*(paysag).*$/, '/fr/collections/pierres-paysagement'],
    
    // Rule 28: Catégories accessoires EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/accesoires.*$/, '/collections/others'],
    
    // Rule 29: Catégories accessoires FR
    [/^(\/index\.php)?\/ca-fr\/(categorie-de-produits)\/accesoires.*$/, '/fr/collections/autres'],
    
    // Rule 30: Catégories others EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(product-categories)\/others.*$/, '/collections/others'],
    
    // Rule 31: Catégories others FR
    [/^(\/index\.php)?\/ca-fr\/(product-categories|categorie-de-produits)\/others.*$/, '/fr/collections/autres'],
    
    // ============================================================
    // GABIONS SECTIONS (32-35)
    // ============================================================
    
    // Rule 32: Gabions subsections
    [/^\/gabions\/(landscape|fence|industrial)-gabions\/?$/, '/collections/gabions'],
    
    // Rule 33: Gabions baskets/stones
    [/^(\/index\.php)?\/gabions-(baskets|stones).*$/, '/collections/gabions'],
    
    // Rule 34: Gabions incomplete
    [/^(\/index\.php)?\/gabions-$/, '/collections/gabions'],
    
    // ============================================================
    // CLEARANCE (35-38)
    // ============================================================
    
    // Rule 35: Clearance products
    [/^\/clearance\/.*$/, '/'],
    
    // Rule 36: Clearance collection
    [/^\/collections\/clearance\/?$/, '/'],
    
    // Rule 37: Clearance categories EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/product-categories\/clearance.*$/, '/'],
    
    // ============================================================
    // OTHER SECTIONS (38-41)
    // ============================================================
    
    // Rule 38: Stones subsections
    [/^\/stones\/.*$/, '/collections/stones'],
    
    // Rule 39: Fountains lighting
    [/^\/fountains-lighting\/.*$/, '/collections/fountains'],
    
    // Rule 40: Glass section
    [/^\/glass\/.*$/, '/collections/glass'],
    
    // ============================================================
    // ENGLISH CITY-BASED PATTERNS (41-70) - with optional city
    // ============================================================
    
    // Rule 41: Decorative stones + ville EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/decorative-stones([\/-][a-zA-Z_-]+)?\/?$/, '/collections/stones'],
    
    // Rule 42: Landscaping stones + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscaping-stones(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 43: Landscaping rocks + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscaping-rocks(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 44: Landscaping stone singular + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscaping-stone(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 45: Landscape stone + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscape-stone(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 46: Landscape rocks + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscape-rocks(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 47: Landscapes-stones typo + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscapes-stones(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 48: Stones for landscaping + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/stones-for-landscaping(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 49: Decorative landscape + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/decorative-landscape(ing)?-stones([\/-][a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 50: Garden stones + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/garden(ing)?-stones(\/[a-zA-Z_-]+)?\/?$/, '/collections/stones'],
    
    // Rule 51: Stones for garden + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/stones-for-garden(\/[a-zA-Z_-]+)?\/?$/, '/collections/stones'],
    
    // Rule 52: Pebble + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/(black-)?pebble(-stone)?(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 53: Landscaping pebbles (added)
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscaping-pebbles?(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 54: Landscape pebble + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/landscape-pebble-stone(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 55: Fire stones + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/(black-)?fire-stones(\/[a-zA-Z_-]+)?\/?$/, '/collections/fire-stones'],
    
    // Rule 56: Fire pebbles (added)
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/fire-pebbles?(\/[a-zA-Z_-]+)?\/?$/, '/collections/fire-stones'],
    
    // Rule 57: Fire rocks + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/fire-rocks(\/[a-zA-Z_-]+)?\/?$/, '/collections/fire-stones'],
    
    // Rule 58: Stones for fire + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/stones-(for|with)-fire(\/[a-zA-Z_-]+)?\/?$/, '/collections/fire-stones'],
    
    // Rule 59: Gaz fire stone + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/gaz-fire-stone(\/[a-zA-Z_-]+)?\/?$/, '/collections/fire-stones'],
    
    // Rule 60: Firepit EN + ville
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(gaz-|stone-)?firepits?(\/[a-zA-Z_-]+)?\/?$/, '/collections/firepits'],
    
    // Rule 61: Firepit FR + ville
    [/^(\/index\.php)?\/ca-fr\/(gaz-|stone-)?firepits?(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/foyers-exterieurs'],
    
    // Rule 62: Lava rocks + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/lava-rocks(\/[a-zA-Z_-]+)?\/?$/, '/collections/lava-rocks'],
    
    // Rule 63: Lava pebbles + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/lava-pebbles(\/[a-zA-Z_-]+)?\/?$/, '/collections/fire-stones'],
    
    // Rule 64: Gabion EN + ville
    [/^(\/index\.php)?(\/ca-en|\/en)?\/gabion-(rocks|basket)(\/[a-zA-Z_-]+)?\/?$/, '/collections/gabions'],
    
    // Rule 65: Cage gabion EN + ville
    [/^(\/index\.php)?(\/ca-en|\/en)?\/cage-gabion([\/-][a-zA-Z_-]+)?\/?$/, '/collections/gabions'],
    
    // Rule 66: Mexican beach + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/mexican-beach-(stone|pebble)(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 67: Mexican black + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/mexican-black-stone(\/[a-zA-Z_-]+)?\/?$/, '/collections/stones'],
    
    // Rule 68: Polished stone EN + ville
    [/^(\/index\.php)?(\/ca-en|\/en)?\/(black-|highly-)?polished-stone-?(\/[a-zA-Z_-]+)?\/?$/, '/collections/polished-pebbles-stones'],
    
    // Rule 69: White stones + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/white-(stones-for-landscaping|rocks-for-gardening)(\/[a-zA-Z_-]+)?\/?$/, '/collections/landscaping-stones'],
    
    // Rule 70: Black stone + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/black-stone(\/[a-zA-Z_-]+)?\/?$/, '/collections/stones'],
    
    // Rule 71: Slate chips + ville
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/slate-chips(\/[a-zA-Z_-]+)?\/?$/, '/collections/stones'],
    
    // ============================================================
    // FRENCH CITY-BASED PATTERNS (72-89) - with optional city
    // ============================================================
    
    // Rule 72: Pierres décoratives FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-decoratives(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 73: Pierres jardins FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-pour-jardins([\/-][a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 74: Pierre à jardin FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierre-a-jardin(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 75: Pierres rondes FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-rondes(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 76: Pierres lisses FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-lisse(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 77: Pierres blanches FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-blanches-(decoratives|pour-amenagment-paysager)(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres-paysagement'],
    
    // Rule 78: Pierres polies FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-(polie-noir|tres-polie(-noir)?)(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/galets-pierres-polies'],
    
    // Rule 79: Pierres noires décoratives FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-noir-decoratives(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 80: Pierres aménagement FR + ville
    [/^(\/index\.php)?\/ca-fr\/pierres-pour-amenagement-paysager(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres-paysagement'],
    
    // Rule 81: Roches noires FR + ville
    [/^(\/index\.php)?\/ca-fr\/roches-noir(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 82: Roches blanches FR + ville
    [/^(\/index\.php)?\/ca-fr\/roches-blanches-decoratives(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres-paysagement'],
    
    // Rule 83: Roches jardins FR + ville
    [/^(\/index\.php)?\/ca-fr\/roches-pour-jardins(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres-paysagement'],
    
    // Rule 84: Roches décoratives FR + ville
    [/^(\/index\.php)?\/ca-fr\/roches-decoratives(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres-paysagement'],
    
    // Rule 85: Ardoise FR + ville
    [/^(\/index\.php)?\/ca-fr\/(paillis|copeaux)-ardoise([\/-][a-zA-Z_-]+)?\/?$/, '/fr/collections/pierres'],
    
    // Rule 86: Foyer FR + ville
    [/^(\/index\.php)?\/ca-fr\/foyer(-a-gaz|-en-pierres)?(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/foyers-exterieurs'],
    
    // Rule 87: Gabion FR + ville
    [/^(\/index\.php)?\/ca-fr\/(gabion-decoratif|gabion-pierre|gabion-cloture|panier-de-gabion|cage-gabion|muret-de-gabion|banc-gabion)(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/gabions'],
    
    // Rule 88: Cage de pierre FR + ville
    [/^(\/index\.php)?\/ca-fr\/cage-de-pierre([\/-][a-zA-Z_-]+)?\/?$/, '/fr/collections/gabions'],
    
    // Rule 89: Mur soutènement FR + ville
    [/^(\/index\.php)?\/ca-fr\/mur-de-soutainement(\/[a-zA-Z_-]+)?\/?$/, '/fr/collections/gabions'],
    
    // ============================================================
    // PRODUCT PAGES (90-93)
    // ============================================================
    
    // Rule 90: Products EN avec locale (preserve handle)
    [/^(\/index\.php)?(\/ca-en|\/en)?\/products\/([a-z0-9_-]+)\/?$/, function(match, p1, p2, p3) { return '/products/' + p3; }],
    
    // Rule 91: Produits FR (preserve handle)
    [/^(\/index\.php)?\/ca-fr\/produits\/([a-z0-9_-]+)\/?$/, function(match, p1, p2) { return '/fr/produits/' + p2; }],
    
    // Rule 92: Products FR mixed (preserve handle)
    [/^(\/index\.php)?\/ca-fr\/products\/([a-z0-9_-]+)\/?$/, function(match, p1, p2) { return '/fr/produits/' + p2; }],
    
    // Rule 93: EN produits mixed (preserve handle)
    [/^\/en\/produits\/([a-z0-9_-]+)\/?$/, function(match, p1) { return '/products/' + p1; }],
    
    // ============================================================
    // GENERIC & FALLBACK RULES (94-105)
    // ============================================================
    
    // Rule 94: Catégorie + region générique
    [/^(\/index\.php)?(\/ca-en|\/ca-fr|\/en)?\/[a-z-]+\/(united-states|canada)\/?$/, '/'],
    
    // Rule 95: Products list page EN
    [/^(\/index\.php)?(\/ca-en|\/en)?\/products\/?$/, '/collections/all'],
    
    // Rule 96: Products list page FR
    [/^(\/index\.php)?\/ca-fr\/products\/?$/, '/fr/collections/tous'],
    
    // Rule 97-98: REMOVED - was redirecting all /fr/ URLs to homepage
    
    // Rule 99: Contact FR
    [/^(\/index\.php)?\/ca-fr\/(contact-1|soumission)\/?$/, '/fr/pages/contact'],
    
    // Rule 100: Uncategorized
    [/^\/uncategorized\/?$/, '/'],
    
    // Rule 101: Broken URLs
    [/^(\/index\.php)?\/ca-en>$/, '/'],
    
    // Rule 102: V1 produce broken
    [/^\/v1\/produce\/?$/, '/'],
    
    // Rule 103: Malformed en/products
    [/^\/index\.php\/[a-z-]+\/en\/products\/?$/, '/collections/all'],
    
    // Rule 104: Malformed ca-en/products
    [/^(\/index\.php)?\/ca-en\/[a-z-]+\/ca-en\/products\/?$/, '/collections/all'],
    
    // Rule 105: Malformed ca-en/faq
    [/^(\/index\.php)?\/ca-en\/[a-z-]+\/ca-en\/faq\/?$/, '/pages/faq']
  ];
  
  for (var i = 0; i < rules.length; i++) {
    var regex = rules[i][0];
    var dest = rules[i][1];
    
    if (regex.test(path)) {
      var newPath;
      if (typeof dest === 'function') {
        newPath = path.replace(regex, dest);
      } else {
        newPath = dest;
      }
      
      if (newPath !== path) {
        window.location.replace(newPath);
        return;
      }
    }
  }
})();